// extracted by mini-css-extract-plugin
var _1 = "Rows_content__b0373";
var _2 = "Rows_row__306d2";
export { _1 as "content", _2 as "row" }
